import React from 'react';

import PropTypes from 'prop-types';
import {
    Button,
    OverlayArrow,
    Tooltip,
    TooltipTrigger,
} from 'react-aria-components';
import InfoCircleIcon from 'react-icons/lib/fa/info-circle';

import {
    DropdownMenu,
    Typography,
    WDSButton,
} from 'wanderu-components';
import { RECOMMENDED } from 'wanderu-ducks-search';
import { localize } from 'wanderu-i18n';

import { LocationPin } from './LocationPin';
import SortOptions from '../SortOptions/SortOptions';
import events from './events/SearchListHeaderEvents';

import styles from './SearchListHeader.scss';

function SearchListHeader(props) {
    const {
        activeSortType = '',
        batchId = '',
        direction = '',
        isStationMapEnabled = false,
        numberOfTripsToShow = 0,
        onMapClick = () => undefined,
        onSort = () => undefined,
        searchParams = {},
        showMap = false,
        sortOptions = {},
        t,
        totalTrips = 0,
    } = props;

    const onHoverInfo = () => {
        events.sortInfoHovered({
            batchId,
            direction,
            totalTrips,
        });
    };

    return (
        <div className={styles.header}>
            <div className={styles.leftColumn}>
                <div className={styles.dropdownContainer}>
                    <DropdownMenu
                        altText={'Sort'}
                        className={styles.dropdown}
                        title={(
                            <span className={styles.sortTitle}>
                                {t('sort-by', {
                                    sortType: t(`${activeSortType}_tag`),
                                })}

                                {activeSortType === RECOMMENDED && (
                                    <TooltipTrigger
                                        closeDelay={150}
                                        delay={150}
                                        onOpenChange={(isOpen) => isOpen && onHoverInfo()}
                                    >
                                        <Button className={styles.infoButton}>
                                            <InfoCircleIcon
                                                alt={t('more-info')}
                                                className={styles.info}
                                                data-for="recommended-info"
                                                style={{ verticalAlign: '-3px' }}
                                                title={t('click-for-more')}
                                            />
                                        </Button>
                                        <Tooltip
                                            className={styles.tooltip}
                                            offset={16}
                                            placement="top"
                                        >
                                            <OverlayArrow className={styles.overlayArrow} />

                                            <div className={styles.tooltip}>
                                                {t('recommended-tooltip')}
                                            </div>
                                        </Tooltip>
                                    </TooltipTrigger>
                                )}
                            </span>
                        )}
                    >
                        <SortOptions
                            activeSortType={activeSortType}
                            onSort={onSort}
                            searchParams={searchParams}
                            sortOptions={sortOptions}
                        />
                    </DropdownMenu>
                </div>
                {isStationMapEnabled && totalTrips > 0
                    ? <WDSButton className={styles.mapButton} onClick={onMapClick} variant="unstyled">
                        <LocationPin />
                        <Typography className={styles.mapText} variant="h6">
                            {showMap
                                ? 'Hide map'
                                : 'Show map'}
                        </Typography>
                    </WDSButton>
                    : null
                }
            </div>
            <div>
                {t('showing-trips', {
                    numberToShow: (
                        <span
                            className={styles.number}
                            key="numberToShow"
                        >
                            {numberOfTripsToShow}
                        </span>
                    ),
                    total: (
                        <span
                            className={styles.number}
                            key="totalTrips"
                        >
                            {totalTrips}
                        </span>
                    ),
                })}
            </div>
        </div>
    );
}

SearchListHeader.propTypes = {
    activeSortType: PropTypes.string,
    batchId: PropTypes.string,
    direction: PropTypes.string,
    isStationMapEnabled: PropTypes.bool,
    numberOfTripsToShow: PropTypes.number,
    onMapClick: PropTypes.func,
    onSort: PropTypes.func,
    searchParams: PropTypes.object,
    showMap: PropTypes.bool,
    sortOptions: PropTypes.object,
    t: PropTypes.func,
    totalTrips: PropTypes.number,
};

export { SearchListHeader };
export default localize(SearchListHeader, ['t'], 'baseApp');
